import { isBrowser } from '@noths/polaris-client-utils';

export const getClientLogger = () => (isBrowser() && window.DD_LOGS?.logger) || console;
